import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { POPOVER_ANIMATION_DURATION, Popover, PopoverType, usePopoverHandlers } from '@as/cotopaxi';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { HtmlInclude } from '../../common/html-include/HtmlInclude';
import { EventUtil } from '@as-react/common-utils';
import { EventEnum } from '@as-react/common-types';
import { Box, LinkButton } from '@yonderland/andes-react';
import { RulerIcon } from '@yonderland/andes-icons';
import { useDispatch, useSelector } from 'react-redux';
import { makeGetSizeGuideData } from '../../../redux/product/selectors/ProductSelector';
import { useAemConfig } from '@as-react/common-components';
import { productActions } from '../../../redux/product/actions/ProductActions';
import { analyticsActions } from '../../../redux/analytics/actions/AnalyticsActions.creators';
export const SizeGuideAlpha = () => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const { pdpTemplateName } = useAemConfig();
    const { sizeGuideContent, sizeGuideContentUrl } = useSelector(makeGetSizeGuideData());
    const dispatch = useDispatch();
    const isPopup = Boolean(sizeGuideContent);
    const [isOpen, setIsOpen] = useState(false);
    const { anchorEl, handlePopoverOpen, handlePopoverClose } = usePopoverHandlers({
        close: () => setIsOpen(false),
    });
    const handleSizeGuideOpen = () => {
        dispatch(productActions.sizeGuideOpen());
        dispatch(analyticsActions.productDetailSizeGuideClick(pdpTemplateName));
        if (isPopup) {
            setIsOpen(true);
        }
        else {
            window.open(sizeGuideContentUrl, '_blank');
        }
    };
    useEffect(() => {
        if (isOpen) {
            handlePopoverOpen(null, null, true);
            setTimeout(() => EventUtil.dispatch(EventEnum.SIZE_GUIDE_POPOVER_OPEN), POPOVER_ANIMATION_DURATION);
        }
    }, [isOpen]);
    if (!sizeGuideContent && !sizeGuideContentUrl) {
        return null;
    }
    return (_jsxs(Box, { children: [_jsx(LinkButton, { testId: "size_guide", iconLeft: { source: RulerIcon, size: 'xs' }, onClick: handleSizeGuideOpen, text: t('product.size.guide.link') }), isPopup && (_jsx(Popover, { anchorEl: anchorEl, type: PopoverType.MODAL, onClose: handlePopoverClose, title: t('product.size.guide.link'), dataQA: "size_guide_popup", children: _jsx(HtmlInclude, { htmlFragment: sizeGuideContent }) }))] }));
};
